export default "__VITE_ASSET__DGRpCRei__"